import VPaintViewer from "./index";
import Vue from "vue";

export default function (configObj) {
  let defaultConfig = {
    carousel: [],
    current: 0,
    transitionName: "attach-reactive",
    swiper: null,
  };

  let config = Object.assign(defaultConfig, configObj);
  let { carousel, current, transitionName, swiper } = config;

  document.querySelector("#paint-viewer")?.remove?.();
  const div = document.createElement("div");
  const el = document.createElement("div");
  div.id = "paint-viewer";
  div.appendChild(el);
  document.body.appendChild(div);

  let instance = null;
  function render() {
    instance = new Vue({
      el,
      components: { VPaintViewer },
      data() {
        return {
          isShow: false,
        };
      },
      methods: {
        on_close() {
          setTimeout(() => {
            this.isShow = false;
            document.body.classList.remove("disabled-scroll");
            $("#navbar").velocity(
              "slideDown",
              $.extend({ display: "flex" }, { duration: 240, delay: 500 })
            );
          }, 100);
        },
        on_destroy() {
          instance.$destroy();
          instance = null;
          div.remove();
        },
        on_change(index) {
          if (swiper?.slideTo) {
            let itemWidth = $(swiper.$el[0])
              .find(`.swiper-slide[index="${index}"]`)
              .outerWidth();
            swiper.slideTo(index, 0, false);
            swiper.translateTo(
              swiper.getTranslate() + $(window).width() / 2 - itemWidth / 2
            );
          }
        },
      },
      created() {
        this.$nextTick(() => {
          this.isShow = true;
          document.body.classList.add("disabled-scroll");
          $("#navbar").velocity("slideUp", { duration: 180 });
        });
      },
      render() {
        return (
          <v-transition name={transitionName} vOn:after-leave={this.on_destroy}>
            {this.isShow ? (
              <VPaintViewer
                isLargeImageOnly={transitionName === "fade"}
                carousel={carousel}
                current={current}
                vOn:close={this.on_close}
                vOn:change={this.on_change}
              />
            ) : null}
          </v-transition>
        );
      },
    });
  }
  render();
}
